import {Component, Input, OnInit} from '@angular/core';
import {NgClass, NgIf, NgStyle} from '@angular/common';

@Component({
    selector: 'app-card-wrapper',
    templateUrl: './card-wrapper.component.html',
    styleUrls: ['./card-wrapper.component.scss'],
    standalone: true,
    imports: [NgStyle, NgClass, NgIf],
})
export class CardWrapperComponent implements OnInit {
    @Input() backgroundImage: string | undefined;
    @Input() backgroundColor: string = '#40348A';
    @Input() backgroundPosition: string = 'bottom'; // 'fullscreen', 'bottom' | 'top'
    @Input() backgroundSize: string = '50%'; // 25% | 50% | 75% | auto
    @Input() overlay: boolean = false;

    constructor() {
    }

    ngOnInit() {
    }


    getGridTemplateRows(): string {
      const backgroundPosition = this.backgroundPosition || 'bottom';

      if (backgroundPosition !== 'fullscreen') {
        if (this.backgroundSize === 'auto') {
          return backgroundPosition === 'top' ? 'auto 1fr' : '1fr auto';
        }

        if (this.backgroundSize === '25%') {
          return backgroundPosition === 'top' ? '1fr 3fr' : '3fr 1fr';
        }

        if (this.backgroundSize === '50%') {
          return backgroundPosition === 'top' ? '1fr 1fr' : '1fr 1fr';
        }

        if (this.backgroundSize === '75%') {
          return backgroundPosition === 'top' ? '3fr 1fr' : '1fr 3fr';
        }
      }

      return 'auto';
    }
}
